import { getCareerAvailableYears } from "../lib/cvDataUtilities.js";
import { formatDate, getDate, getYears, zeroPad } from "../lib/dateHelpers.js";
import { escapeHtml, getProp } from "../lib/frontendUtilities.js";
import { getLastPosition } from "../lib/reportUtilities.js";
import { clone, getKey, keys } from "../lib/utilities.js";
import { CCManage } from "./cclib/CCManage.ts";

var sortBy = "mentor";
var mentees = [];

export default {
  title: "Stanford",
  tabTitle: "Annual Review",
  defaults: {
    questions: ["1", "2", "3", "4", "5", "6a", "7a", "6b", "7b", "8"],
    questionCaptions: [
      "Describe other area(s) of academic contribution, if applicable",
      "Faculty Member’s Key Achievement Summary (Clinical, Nonclinical, or Both) for Past Year <span class='wordLimit' style='font-weight: bold;' data-type='2'>(250 word limit)</span>:",
      "Faculty Member’s Goals/Priorities for the Upcoming Year <span class='wordLimit' style='font-weight: bold;' data-type='3'>(250 word limit)</span>:",
      "Other comments or uncategorized items you would like to discuss during your review <span class='wordLimit' style='font-weight: bold;' data-type='4'>(250 word limit)</span>:",
      "Goals/milestones/achievements during the past year:",
      "The following matters were identified as important in the faculty member’s short (1-3 years) and long-term (5-10 years) plans:",
      "I have provided counsel regarding areas to focus on for the next year as follows:",
      "The following matters were identified as important in the faculty member’s development over the next year:",
      "I have provided counsel regarding career development and areas to focus on for the next year as follows:",
      "Please outline any counseling, recommendations for further training, referral for coaching or follow-up related to the comments on MedHub evaluations:"
    ]
  },
  cvSetup: function ({
    contextMethods,
    contextConstants,
    contextState,
    conference,
    backend
  }) {
    let { refreshSection, updateLayout, checkSave } = contextMethods;
    let { user, cvOwner, users, mentors, conferences } = contextConstants;
    let {
      section,
      sectionState,
      format,
      newDef,
      viewAsState,
      customExportSettings
    } = contextState;

    var editAccessOverride =
      (user.settings.accessFilters || []).length > 0 &&
      user.settings.conferenceTabAccess == "editAccess";
    var menteeOverride = false;
    var mentorOverride = false;

    var menteeAccess =
      user.id == cvOwner.id || editAccessOverride || menteeOverride;
    var overviewState = getKey(sectionState, section, {});

    var mentorAccess =
      (conference.mentors[user.id] || {})[cvOwner.id] != null ||
      editAccessOverride ||
      mentorOverride;
    var managerAccess = editAccessOverride;

    $("#fieldList").empty();

    $("#fieldList").append(
      $(
        "" +
          "<div>" +
          '   <div class="btn btn-default careerYearPrev" style="margin-right: 15px; margin-bottom: 8px;">' +
          '   <span class="glyphicon glyphicon-arrow-left"></span>' +
          "   </div>" +
          '   <h4 class="careerYear" style="margin-right: 15px;display: inline-block;margin-top: 7px;vertical-align: top;">Year: </h4>' +
          '   <div class="btn btn-default careerYearNext" style="margin-right: 15px;vertical-align: top;"><span class="glyphicon glyphicon-arrow-right"></span></div>' +
          '   <div class="btn btn-primary limitedCVCareerDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Date Limited CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary fullDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Full CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary stanfordReviewForm" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          '     <span class="stanfordReviewFormTitle">Review Form</span>' +
          "   </div>" +
          '   <div class="btn btn-primary stanfordCounselingForm" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          '     <span class="stanfordCounselingFormTitle">Counselling Form</span>' +
          "   </div>" +
          " </div>"
      )
    );

    $(".careerReportPrint")
      .unbind("click")
      .click(function () {
        updateHTML({ readOnly: true });
        var printContents = $("#printableContents")[0].innerHTML;
        var w = window.open("", "Test");
        w.document.write(
          '<link rel="stylesheet" href="/css/bootstrap.min.css"/>'
        );
        w.document.write(
          "<style> @media print {  @page { margin: 1in; } } </style>"
        );
        var yearRange = $(".careerYear").text();
        w.document.write(
          '<div style="padding: 15px;"><h4 style="">' +
            yearRange +
            " " +
            (cvOwner.name || "") +
            " Career Conference</h4>" +
            printContents +
            "</div>"
        );
        updateHTML();
        w.document.title =
          yearRange + " " + (cvOwner.name || "") + " Career Conference";
        setTimeout(function () {
          w.print();
          // w.close();
        }, 1000);
      });

    $(".limitedCVCareerDownload")
      .unbind("click")
      .click(function () {
        var overviewState = getKey(sectionState, section, {});

        var yearInfo = getCareerAvailableYears(
          newDef,
          conference,
          user,
          cvOwner
        );
        var availableYears = yearInfo.availableYears;
        var baseYear = yearInfo.baseYear;
        if (
          overviewState.yearIndex == null ||
          availableYears[overviewState.yearIndex] == null
        )
          overviewState.yearIndex = availableYears.findIndex(function (n) {
            return n == baseYear;
          });
        var viewYear = availableYears[overviewState.yearIndex];

        var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
        var month = cutoff.split("/")[0] || "1";
        var date = cutoff.split("/")[1] || "1";

        customExportSettings.dateLimited = true;
        customExportSettings.shown = true;

        var endDate = new Date(
          viewYear + 1,
          parseInt(month) - 1,
          parseInt(date) - 1
        );
        $("#m1").val(month);
        $("#m2").val(endDate.getMonth() + 1);
        $("#d1").val(date);
        $("#d2").val(endDate.getDate());
        $("#y1").val(viewYear + (format == "stanford_anesthesia" ? -1 : 0));
        $("#y2").val(endDate.getYear() + 1900);
        $(".download").trigger("click");
      });

    var mentorList = keys(conference.mentors).filter(function (id) {
      return conference.mentors[id][cvOwner.id] != null && mentors[id] != null;
    });

    if (mentorList.length > 0) {
      $("#fieldList").append(
        $(
          "" +
            '<div id="confSelectSection" style="margin-bottom: 10px;display: inline-block;width: 100%;">' +
            '  <h4 style="display: inline-block;margin-right: 5px;">Career Conference Mentor' +
            (mentorList.length > 1 ? "s" : "") +
            ": " +
            mentorList
              .map(function (mId) {
                return escapeHtml(mentors[mId].name);
              })
              .join(", ") +
            "</h4>" +
            "</div>"
        )
      );
    }

    $("#fieldList").append(
      $(`<span style="display: inline-block; margin-top: 10px;"><p><b>All faculty members are required to complete and submit this review form along with an updated CV as part of the annual self-assessment process.</b> Faculty members should report activities and achievements for the past year (since <u>1 July</u>) and plan specific goals for the coming year in each of their academic areas as applicable. </p>
      <p>Each faculty member must meet with the Division Chief, Associate Division Chief or other Departmental leader at least once per year, and this form will be used to guide the discussion. <b>This form will be reviewed by the Governance Committee for clinical commitment assignment and is intended to highlight the nonclinical/academic work being contributed beyond what is considered professional citizenship. </b></p>
      <p>During your annual review meeting, please plan to discuss the following questions:
      <ul><li>What brings you the greatest sense of meaning and/or purpose at work?</li>
      <li>What professional activities or accomplishments were most important to you last year?</li>
      <li>How can the Department better support you in achieving your career and work-life integration goals?</li></ul></p><p><b>To fill out the tables, please provide a self-assessment of each of your academic activities from the past year divided by Departmental mission area, as applicable.</b> In each section, describe each activity, list support and end date, if applicable, and note any achievements through the activity for the past year. Achievements should be briefly noted, as a more extensive description can be added in the self-assessment section.  
      </p><p><u><b>Guidance on use of the form and definitions</b></u>
      Prioritize your achievements/tasks by time, impact or personal value, and group items together where appropriate (e.g., 3 book chapters, 2 first-authored manuscripts; gave 4 resident lectures; 3 national talks, etc.)  To keep the review simple, please do not exceed the provided space (i.e., <u>do not</u> add additional lines, expand the line spaces, or add content outside the tables and boxes provided).
      </p><p><b>*Support:</b> If yes, you receive designated support for the activity--from NIH or other grants, the hospital (e.g., medical director), School (e.g., E4C, Deanship), or Department (e.g., teaching scholars, CELT, leadership roles).</p>
      </span>`)
    );

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top;margin-top: 3px;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;">Missing Information Required Before Submission</h5>' +
          '  <h5 class="statusSubheader">When finished, mark as complete to notify your mentor.</h5>' +
          "</div>"
      )
    );

    var last = getLastPosition(newDef, { format });
    if (
      last != null &&
      last.time != null &&
      last.time.start != null &&
      !isNaN(getYears(last.time.start))
    ) {
      var dateText = getDate(last);
      var yearsLong = Math.round(last.years * 10) / 10;
      $("#fieldList").append(
        $(
          "" +
            '<div style="margin-bottom: 10px;margin-top: 10px;">' +
            '  <h4 style="margin-bottom: 10px; display: inline-block;">Academic Title: <span id="careerConfCurrentTitle"><u class="sectionTab" data-section="facultyAppointments">' +
            escapeHtml(last.title) +
            " (" +
            escapeHtml(dateText) +
            ")</u> for " +
            yearsLong +
            " year" +
            (yearsLong != 1 ? "s" : "") +
            "</span></h4>" +
            "<div>"
        )
      );
    }

    var printableContents = $('<span id="printableContents"></span>');
    $("#fieldList").append(printableContents);

    // Find which years are available. Should be just years which have data or which are open, or if you have mentorAccess
    var yearInfo = getCareerAvailableYears(newDef, conference, user, cvOwner);
    var availableYears = yearInfo.availableYears;
    var baseYear = yearInfo.baseYear;

    var overviewState = getKey(sectionState, section, {});
    if (
      overviewState.yearIndex == null ||
      availableYears[overviewState.yearIndex] == null
    )
      overviewState.yearIndex = availableYears.findIndex(function (n) {
        return n == baseYear;
      });

    printableContents.append(
      $('<div class="btn btn-default careerCopyForward">Copy Forward All</div>')
    );

    $(".careerCopyForward")
      .unbind("click")
      .click(function () {
        var overviewState = getKey(sectionState, section, {});
        if (
          overviewState.yearIndex == null ||
          availableYears[overviewState.yearIndex] == null
        )
          overviewState.yearIndex = availableYears.findIndex(function (n) {
            return n == baseYear;
          });
        var viewYear = availableYears[overviewState.yearIndex];

        var yearData = getKey(newDef.career, viewYear, {
          timeBreakdown: {},
          goals: {},
          status: "mentee",
          questions: {},
          mentorComments: "",
          details: {}
        });

        var lastYearData = newDef.career[viewYear - 1] || {
          timeBreakdown: {},
          goals: {},
          status: "mentee",
          questions: {},
          mentorComments: "",
          details: {}
        };

        yearData.timeBreakdown = clone(lastYearData.timeBreakdown);
        yearData.details = clone(lastYearData.details);
        yearData.questions = clone(lastYearData.questions);

        checkSave();
        updateHTML();
      });

    $(".stanfordReviewForm")
      .unbind("click")
      .click(function () {
        var template = "/templateFiles/reports/stanford_review_form_v1.docx";
        var oReq = new XMLHttpRequest();
        oReq.open("GET", template, true);
        oReq.responseType = "arraybuffer";
        oReq.onload = function () {
          var arrayBuffer = oReq.response;
          var content = new Uint8Array(arrayBuffer);
          var zip = new PizZip(content);
          var doc = new Docxtemplater();
          doc.loadZip(zip);
          doc.setOptions({ linebreaks: true });

          var last = getLastPosition(newDef, { format });
          var stanfordLine = getKey(
            getKey(newDef, "narrative", {}),
            "stanfordLine",
            ""
          );

          var overviewState = getKey(sectionState, section, {});
          var yearInfo = getCareerAvailableYears(
            newDef,
            conference,
            user,
            cvOwner
          );
          var availableYears = yearInfo.availableYears;
          var baseYear = yearInfo.baseYear;
          if (
            overviewState.yearIndex == null ||
            availableYears[overviewState.yearIndex] == null
          )
            overviewState.yearIndex = availableYears.findIndex(function (n) {
              return n == baseYear;
            });
          var viewYear = availableYears[overviewState.yearIndex];
          var yearData = newDef.career[viewYear];

          var data = {
            name: cvOwner.name,
            year: viewYear + 1,
            rank:
              {
                fellow: "Fellow",
                assistant: "Assistant Professor",
                associate: "Associate Professor",
                full: "Full Professor"
              }[(last || {}).role] || "Unknown",
            line:
              {
                uml: "UML/UTL",
                ce: "CE" // , any: 'Any'
              }[stanfordLine] || "",
            p1:
              (yearData.timeBreakdown["clinical"] == null
                ? 0
                : yearData.timeBreakdown["clinical"]) + "%",
            p2:
              (yearData.timeBreakdown["research"] == null
                ? 0
                : yearData.timeBreakdown["research"]) + "%",
            p3:
              (yearData.timeBreakdown["teaching"] == null
                ? 0
                : yearData.timeBreakdown["teaching"]) + "%",
            p4:
              (yearData.timeBreakdown["leadership"] == null
                ? 0
                : yearData.timeBreakdown["leadership"]) + "%",
            p5:
              (yearData.timeBreakdown["admin"] == null
                ? 0
                : yearData.timeBreakdown["admin"]) + "%",
            aa1: yearData.details["patientcare"].list.map(function (n) {
              return {
                1: n.text || "",
                2: (
                  [
                    { key: "none", text: "Not Set" },
                    { key: "yes", text: "Yes" },
                    { key: "no", text: "No" }
                  ].find(function (item) {
                    return item.key == n.support;
                  }) || { text: "Not Set" }
                ).text,
                3: n.achievements || ""
              };
            }),
            aa2: yearData.details["scholarship"].list.map(function (n) {
              return {
                1: n.text || "",
                2: (
                  [
                    { key: "none", text: "Not Set" },
                    { key: "yes", text: "Yes" },
                    { key: "no", text: "No" }
                  ].find(function (item) {
                    return item.key == n.support;
                  }) || { text: "Not Set" }
                ).text,
                3: n.achievements || ""
              };
            }),
            aa3: yearData.details["teaching"].list.map(function (n) {
              return {
                1: n.text || "",
                2: (
                  [
                    { key: "none", text: "Not Set" },
                    { key: "yes", text: "Yes" },
                    { key: "no", text: "No" }
                  ].find(function (item) {
                    return item.key == n.support;
                  }) || { text: "Not Set" }
                ).text,
                3: n.achievements || ""
              };
            }),
            aa4: yearData.details["admin"].list.map(function (n) {
              return {
                1: n.text || "",
                2: (
                  [
                    { key: "none", text: "Not Set" },
                    { key: "yes", text: "Yes" },
                    { key: "no", text: "No" }
                  ].find(function (item) {
                    return item.key == n.support;
                  }) || { text: "Not Set" }
                ).text,
                3: n.achievements || ""
              };
            }),
            f1: (yearData.questions[1] || { text: "" }).text || "",
            f2: (yearData.questions[2] || { text: "" }).text || "",
            f3: (yearData.questions[3] || { text: "" }).text || "",
            f4: (yearData.questions[4] || { text: "" }).text || ""
          };

          doc.setData(data);
          try {
            doc.render();
          } catch (error) {
            console.log({
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties
            });
            throw error;
          }

          var dateString =
            new Date().getYear() +
            1900 +
            "-" +
            zeroPad(new Date().getMonth() + 1, 2) +
            "-" +
            zeroPad(new Date().getDate(), 2);
          var docFile = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          });

          var fileName =
            "Review_Form_" +
            cvOwner.name
              .split(",")
              .join("")
              .split(".")
              .join("")
              .split(" ")
              .join("_") +
            "_" +
            dateString +
            ".docx";

          backend.send("saveLog", {
            id: user.id,
            path: window.location.pathname,
            action: JSON.stringify({
              type: "download Stanford Review Form",
              title: fileName.split("\n").join("")
            }),
            context: JSON.stringify({
              agent: window.navigator.userAgent,
              params: window.location.search,
              cvId: cvId,
              cvOwner: cvOwner.id
            })
          });

          saveAs(docFile, fileName.split("\n").join(""));
        };
        oReq.send();
      });

    $(".stanfordCounselingForm")
      .unbind("click")
      .click(function () {
        var last = getLastPosition(newDef, { format });

        var template =
          last != null && last.role == "full"
            ? "/templateFiles/reports/stanford_professor_counseling_form_v1.docx"
            : "/templateFiles/reports/stanford_non_professor_counseling_form_v1.docx";

        var oReq = new XMLHttpRequest();
        oReq.open("GET", template, true);
        oReq.responseType = "arraybuffer";
        oReq.onload = function () {
          var arrayBuffer = oReq.response;
          var content = new Uint8Array(arrayBuffer);
          var zip = new PizZip(content);
          var doc = new Docxtemplater();
          doc.loadZip(zip);
          doc.setOptions({ linebreaks: true });

          var stanfordLine = getKey(
            getKey(newDef, "narrative", {}),
            "stanfordLine",
            ""
          );

          var overviewState = getKey(sectionState, section, {});
          var yearInfo = getCareerAvailableYears(
            newDef,
            conference,
            user,
            cvOwner
          );
          var availableYears = yearInfo.availableYears;
          var baseYear = yearInfo.baseYear;
          if (
            overviewState.yearIndex == null ||
            availableYears[overviewState.yearIndex] == null
          )
            overviewState.yearIndex = availableYears.findIndex(function (n) {
              return n == baseYear;
            });
          var viewYear = availableYears[overviewState.yearIndex];
          var yearData = newDef.career[viewYear];

          var mentorList = keys(conference.mentors).filter(function (id) {
            return (
              conference.mentors[id][cvOwner.id] != null && mentors[id] != null
            );
          });

          if (mentorList.length > 0) {
            $("#fieldList").append(
              $(
                "" +
                  '<div id="confSelectSection" style="margin-bottom: 10px;display: inline-block;width: 100%;">' +
                  '  <h4 style="display: inline-block;margin-right: 5px;">Career Conference Mentor' +
                  (mentorList.length > 1 ? "s" : "") +
                  ": " +
                  mentorList
                    .map(function (mId) {
                      return escapeHtml(mentors[mId].name);
                    })
                    .join(", ") +
                  "</h4>" +
                  "</div>"
              )
            );
          }

          // Need to get the mentors
          var dataSet = getKey(yearData, "data", {});

          var chairSign = getKey(dataSet, "chairSign", {}); // { id: , time: }
          var menteeSign = getKey(dataSet, "menteeSign", {}); // { id: , time: }

          var data = {
            name: cvOwner.name,
            rank:
              {
                fellow: "Fellow",
                assistant: "Assistant Professor",
                associate: "Associate Professor",
                full: "Full Professor"
              }[(last || {}).role] || "Unknown",
            line:
              {
                uml: "UML/UTL",
                ce: "CE" // , any: 'Any'
              }[stanfordLine] || "",
            year: viewYear + 1,
            date: dataSet.meetingDate || "",
            endDate: dataSet.aptEndDate || "",
            a1: dataSet.aptChoice == "reapt",
            a2: dataSet.aptChoice == "oneyear",
            a3: dataSet.aptChoice == "tbd",
            c1: !!dataSet.reviewed,
            c2: !!dataSet.discussed,
            c3: !!dataSet.reviewedMedhub,
            t17: (dataSet.otherTopic || "").length > 0,
            tOther: dataSet.otherTopic || "____",
            mentor:
              mentorList
                .map(function (mId) {
                  return mentors[mId].name;
                })
                .join(", ") || "",
            f1: (yearData.questions[5] || {}).text || "",
            f2: (yearData.questions[6] || {}).text || "",
            f3: (yearData.questions[7] || {}).text || "",
            f4: (yearData.questions[8] || {}).text || "",
            s1:
              chairSign.id == null
                ? ""
                : (users[chairSign.id] || { name: "" }).name,
            d1:
              chairSign.id == null ? "" : formatDate(new Date(chairSign.time)),
            s2:
              menteeSign.id == null
                ? ""
                : (users[menteeSign.id] || { name: "" }).name,
            d2:
              menteeSign.id == null
                ? ""
                : formatDate(new Date(menteeSign.time)),
            p1:
              (yearData.timeBreakdown["clinical"] == null
                ? 0
                : yearData.timeBreakdown["clinical"]) + "%",
            p2:
              (yearData.timeBreakdown["research"] == null
                ? 0
                : yearData.timeBreakdown["research"]) + "%",
            p3:
              (yearData.timeBreakdown["teaching"] == null
                ? 0
                : yearData.timeBreakdown["teaching"]) + "%",
            p4:
              (yearData.timeBreakdown["leadership"] == null
                ? 0
                : yearData.timeBreakdown["leadership"]) + "%",
            pOther:
              (yearData.timeBreakdown["admin"] == null
                ? 0
                : yearData.timeBreakdown["admin"]) + "%"
          };

          var topicList = [
            "Clinical Activities",
            "Scholarship",
            "Teaching",
            "Mentorship",
            "Institutional Service and Administrative Activities",
            "Leadership",
            "Professionalism and Collegiality",
            "Academic/professional support (mentorship, learning opportunities, resources)",
            "Quality Improvement Activities",
            "Contributions to Diversity and Inclusion",
            "Advocacy",
            "Professional Development",
            "Achievement of Career Goals",
            "Percent time of appointment and allocation of effort",
            "Any planned sabbatical or leave",
            "Financial Issues"
          ];
          var topics = getKey(dataSet, "topics", {});
          topicList.map((n, i) => (data["t" + (i + 1)] = !!topics[n]));

          doc.setData(data);
          try {
            doc.render();
          } catch (error) {
            console.log({
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties
            });
            throw error;
          }

          var dateString =
            new Date().getYear() +
            1900 +
            "-" +
            zeroPad(new Date().getMonth() + 1, 2) +
            "-" +
            zeroPad(new Date().getDate(), 2);
          var docFile = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          });

          var fileName =
            "Counseling_Form_" +
            cvOwner.name
              .split(",")
              .join("")
              .split(".")
              .join("")
              .split(" ")
              .join("_") +
            "_" +
            dateString +
            ".docx";

          backend.send("saveLog", {
            id: user.id,
            path: window.location.pathname,
            action: JSON.stringify({
              type: "download Stanford Counseling Form",
              title: fileName.split("\n").join("")
            }),
            context: JSON.stringify({
              agent: window.navigator.userAgent,
              params: window.location.search,
              cvId: cvId,
              cvOwner: cvOwner.id
            })
          });

          saveAs(docFile, fileName.split("\n").join(""));
        };
        oReq.send();
      });

    var timeKeys = [
      { name: "Clinical and Patient Care", key: "clinical" },
      { name: "Scholarship and Research", key: "research" },
      { name: "Teaching and Mentorship", key: "teaching" },
      { name: "Service and Leadership", key: "leadership" },
      { name: "Other", key: "admin" }
    ];

    printableContents.append(
      $(
        "" +
          '<div style="margin-bottom: 30px;margin-top: 30px;">' +
          "  <h4>Academic Activity Breakdown</h4>" +
          timeKeys
            .map(function (item, i) {
              return (
                "" +
                '<div style="display: block; margin-bottom: 5px;">' +
                '<span class="careerTimeBreakdownInputText" style="display: inline-block; width: 80px; margin-right: 0px; text-align: center;" data-type="' +
                item.key +
                '"></span>' +
                '<input class="form-control careerTimeBreakdownInput" data-type="' +
                item.key +
                '" style="display: inline-block;width: 80px;margin-right: 5px; text-align: center">' +
                "<span>% - <b>" +
                escapeHtml(item.name) +
                "</b></span>" +
                "</div>"
              );
            })
            .join("") +
          '<div style="display: block; margin-bottom: 5px;">' +
          '  <span class="careerTimeTotal" style="display: inline-block;width: 80px;margin-right: 0px; text-align: center">100</span>' +
          ' <span>% <b style="margin-left: 8px;">Total</b></span>' +
          "</div>" +
          "<div>"
      )
    );

    printableContents.append(
      $(
        '<h4 style="text-decoration: underline;">Departmental Contributions & Academic Activities</h4>'
      )
    );
    printableContents.append($('<div id="careerConfStanfordAA"></div>'));
    printableContents.append(
      $(
        '<h4 id="careerConfStanfordCounselTitle" style="text-decoration: underline;">Counselling Form</h4>'
      )
    );
    printableContents.append($('<div id="careerConfStanfordCounsel"></div>'));
    printableContents.append(
      $(
        "" +
          `<div id="stanfordSignSection">
<div style="margin-bottom: 5px;">
<h4 id="stanfordSignChairLine" style="display: inline-block;margin-right: 10px; font-weight: normal;"><b>Signature of Chair/Chief/Delegate: </b><i>(Not Yet Signed)</i></h4><div id="stanfordSignChairButton" class="btn btn-success">Digitally Sign</div>
</div>
<div style="margin-bottom: 5px;">
<h4 id="stanfordSignMenteeLine" style="display: inline-block;margin-right: 10px; font-weight: normal;"><b>Signature of Faculty Member: </b></h4><div id="stanfordSignMenteeButton" class="btn btn-success">Digitally Sign</div>
</div>
</div>`
      )
    );

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn nextStatus btn-success disabled" style="vertical-align: top; margin-top: 3px; display: inline-block;">Submit for Review</div>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top; margin-top: 3px; display: none;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;"></h5>' +
          '  <h5 class="statusSubheader" style="display: none;">When finished, submit for review to notify your mentor</h5>' +
          "</div>"
      )
    );

    var careerErrorCheck = function () {
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: ""
      });

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess; // For managers, it's always open.

      var totalPercent = 0;
      (timeKeys || []).map(function (item) {
        if (!isNaN(yearData.timeBreakdown[item.key]))
          totalPercent += yearData.timeBreakdown[item.key];
      });
      if (isNaN(totalPercent)) totalPercent = 0;

      var errors = [];
      var hasError = false;
      if (!isOpen) {
      } else if (yearData.status == "mentee") {
        hasError = totalPercent != 100;
      }

      if (!isOpen) {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      } else if (yearData.status == "mentee" && menteeAccess) {
        $(".statusSubheader").text(
          "When finished, submit for review to notify your mentor"
        );
        $(".errorSubheader").text(errors.join(", "));
      } else if (yearData.status == "mentor" && mentorAccess) {
        $(".statusSubheader").text("When finished, mark as finalized");
        $(".errorSubheader").text(
          "Missing information required before finalizing"
        );
      } else {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      }

      $(".statusSubheader").toggle(!hasError);
      $(".errorSubheader").toggle(hasError);

      $(".errorSubheader")
        .unbind("click")
        .click(function () {
          $(".has-error")[0].scrollIntoView();
        });
      $(".nextStatus").toggleClass("disabled", hasError);
    };

    var updateHTML = function (opts) {
      opts = opts || {};
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
      var month = cutoff.split("/")[0] || "1";
      var date = cutoff.split("/")[1] || "1";

      var startDate = new Date(month + "/" + date + "/" + viewYear).getTime();
      var endDate =
        new Date(month + "/" + date + "/" + (viewYear + 1)).getTime() -
        1000 * 60 * 60 * 24;

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: "",
        details: {}
      });

      getKey(yearData, "status", "mentee"); // mentee, mentor, finalized

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess;

      $(
        "#careerConfStanfordCounselTitle, #careerConfStanfordCounsel, .stanfordCounselingForm"
      ).toggle(
        ["mentor", "finalized"].indexOf(yearData.status) >= 0 &&
          (user.id == cvOwner.id ||
            (conference.mentors[user.id] || {})[cvOwner.id] != null)
      );
      $("#stanfordSignSection").toggle(
        ["finalized"].indexOf(yearData.status) >= 0
      );
      $(".careerCopyForward").toggle(
        newDef.career[viewYear - 1] != null && yearData.status == "mentee"
      );

      $(".stanfordReviewFormTitle").text(viewYear + 1 + " Review Form");
      $(".stanfordCounselingFormTitle").text(
        viewYear + 1 + " Counselling Form"
      );

      var isReadOnly = function (yearData, type, thisOpts) {
        thisOpts = thisOpts || {};
        if (opts.readOnly) return true;
        var editAccessOverride =
          (user.settings.accessFilters || []).length > 0 &&
          user.settings.conferenceTabAccess == "editAccess";
        if (thisOpts.noOverride) editAccessOverride = false;
        var menteeOverride = false;
        var mentorOverride = false;

        if (viewAsState !== "undefined" && editAccessOverride) {
          editAccessOverride = false;
          if (viewAsState.career == "mentee") menteeOverride = true;
          else if (viewAsState.career == "mentor") mentorOverride = true;
          else editAccessOverride = true;
        }

        var menteeAccess =
          user.id == cvOwner.id || editAccessOverride || menteeOverride;
        var mentorAccess =
          (conference.mentors[user.id] || {})[cvOwner.id] != null ||
          editAccessOverride ||
          mentorOverride;
        return (
          !isOpen ||
          (yearData.status != type && !mentorAccess && !thisOpts.noOverride) ||
          (type == "mentee" && !menteeAccess) ||
          (type == "mentor" && !mentorAccess)
        );
      };

      $(".generalMentorCommentSection").toggle(
        isOpen &&
          (yearData.status != "mentee" ||
            mentorAccess ||
            (yearData.mentorComments || "").length > 0)
      );

      $(".statusTitle").text(
        "Status: " +
          (!isOpen
            ? "Closed"
            : {
                mentee: "Mentee Editing",
                mentor: "Mentor Review",
                finalized: "Finalized"
              }[yearData.status])
      );

      $(".nextStatus, .prevStatus").hide();
      if (!isOpen) {
      } else if (yearData.status == "mentee") {
        if (menteeAccess) $(".nextStatus").show().text("Submit for Review");
      } else if (yearData.status == "mentor") {
        if (menteeAccess && !!confYearData.open)
          $(".prevStatus").show().text("Resume Editing");
        if (mentorAccess) $(".nextStatus").show().text("Finalize Review");
      } else if (yearData.status == "finalized") {
        if (mentorAccess) $(".prevStatus").show().text("Resume Review");
      }

      var getYearText = function (obj) {
        return (
          obj.getMonth() +
          1 +
          "/" +
          obj.getDate() +
          "/" +
          (obj.getYear() + 1900 + "").slice(-2)
        );
      };
      if (isNaN(startDate)) debugger;

      $(".careerYear").html(
        "<span>" +
          getYearText(new Date(startDate)) +
          " - " +
          getYearText(new Date(endDate)) +
          "</span>" +
          (!isOpen || yearData.status == "closed"
            ? '<span class="glyphicon glyphicon-lock" style="margin-left: 10px;"></span>'
            : "")
      );

      $(".careerYearPrev")
        .css("visibility", overviewState.yearIndex > 0 ? "" : "hidden")
        .unbind("click")
        .click(function () {
          // Only go back if previous data exists
          overviewState.yearIndex--;
          updateHTML();
        });
      $(".careerYearNext")
        .toggle(overviewState.yearIndex < availableYears.length - 1)
        .unbind("click")
        .click(function () {
          overviewState.yearIndex++;
          updateHTML();
        });

      var totalPercent = 0;
      (timeKeys || []).map(function (item, i) {
        var timeBreakdownInput = $(
          '.careerTimeBreakdownInput[data-type="' + item.key + '"]'
        );
        timeBreakdownInput.unbind("input").on("input", function () {
          var key = getProp(this, "type");
          var num = parseInt($(this).val());
          if ($(this).val().trim().length == 0) num = 0;

          var yearData = newDef.career[viewYear];

          var amountErr = isNaN(num) || num < 0 || num > 100;
          $(this).parent().toggleClass("has-error", amountErr);
          if (amountErr) return;
          yearData.timeBreakdown[key] = num;

          var newTotal = 0;
          timeKeys.map(function (item) {
            if (!isNaN(yearData.timeBreakdown[item.key]))
              newTotal += yearData.timeBreakdown[item.key];
          });
          if (isNaN(newTotal)) return;
          $(".careerTimeTotal")
            .text(newTotal)
            .css("color", newTotal != 100 ? "red" : "black")
            .toggleClass("has-error", newTotal != 100);

          checkSave();
          careerErrorCheck();
        });

        var val = yearData.timeBreakdown[item.key];
        timeBreakdownInput.show().val(val != null ? val : 0);
        $('.careerTimeBreakdownInputText[data-type="' + item.key + '"]')
          .hide()
          .text(val != null ? val : 0);

        if (!isNaN(yearData.timeBreakdown[item.key]))
          totalPercent += yearData.timeBreakdown[item.key];
      });

      if (isNaN(totalPercent)) totalPercent = 0;
      $(".careerTimeTotal")
        .text(totalPercent)
        .css("color", totalPercent != 100 ? "red" : "black")
        .toggleClass("has-error", totalPercent != 100);

      careerErrorCheck();

      $(".nextStatus")
        .unbind("click")
        .click(function () {
          if ($(this).hasClass("disabled")) {
            $(".has-error")[0].scrollIntoView();
            return;
          }
          var yearData = newDef.career[viewYear];

          var logText = JSON.stringify({
            cvOwnerId: cvOwner.id,
            userId: user.id,
            data: newDef.career
          });
          backend.send("log", logText);
          // $.get('/log?text='+encodeURIComponent(logText));

          if (yearData.status == "mentee") {
            var check = confirm(
              "Are you sure you are ready to submit? This will send a notification to your mentor that you have completed this form."
            );
            if (!check) return;
            yearData.status = "mentor";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "mentorAlert1",
              data: {
                mentorList: mentorList,
                cvOwnerId: cvOwner.id
              }
            });
          } else if (yearData.status == "mentor") {
            var check = confirm(
              "Are you sure you are ready to finalize? This will send a notification to your mentee that you have completed this review."
            );
            if (!check) return;
            yearData.status = "finalized";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "menteeAlert1",
              data: {
                mentorId: user.id,
                cvOwnerId: cvOwner.id
              }
            });
          }
          checkSave();
          updateHTML();
        });

      $(".prevStatus")
        .unbind("click")
        .click(function () {
          if (yearData.status == "mentor") yearData.status = "mentee";
          else if (yearData.status == "finalized") yearData.status = "mentor";
          // getKey(yearData, 'statusTimes', {})[yearData.status] = Date.now();
          checkSave();
          updateHTML();
        });

      $('.careerQuestionInput[data-type="0"]').val(
        (yearData.questions["0"] || {}).text
      );

      $("#careerConfStanfordAA, #careerConfStanfordCounsel").empty();

      var getBasicRow = function (i, key, detailInfo) {
        detailInfo = detailInfo || {};
        if (isReadOnly(yearData, "mentee")) {
          return (
            '<tr data-i="' +
            i +
            '">' +
            "<td>" +
            (detailInfo.text || "") +
            "</td>" +
            '<td style="vertical-align: top; width: 130px;">' +
            (
              [
                { key: "none", text: "Not Set" },
                { key: "yes", text: "Yes" },
                { key: "no", text: "No" }
              ].find(function (item) {
                return item.key == detailInfo.support;
              }) || { text: "Not Set" }
            ).text +
            "</td>" +
            "<td>" +
            (detailInfo.achievements || "") +
            "</td>" +
            "<td></td>" +
            "</tr>"
          );
        }

        return (
          '<tr data-i="' +
          i +
          '">' +
          '<td><textarea class="form-control detailInput1" style="height: 100px; resize: none;">' +
          (detailInfo.text || "") +
          "</textarea></td>" +
          '<td style="vertical-align: top;"><select class="form-control detailInput2" style="width: 130px;">' +
          [
            { key: "none", text: "Not Set" },
            { key: "yes", text: "Yes" },
            { key: "no", text: "No" }
          ]
            .map(function (item) {
              return (
                '<option value="' +
                item.key +
                '" ' +
                (item.key == detailInfo.support ? " selected" : "") +
                ">" +
                item.text +
                "</option>"
              );
            })
            .join("") +
          "</select></td>" +
          '<td><textarea class="form-control detailInput3" style="height: 100px; resize: none;">' +
          (detailInfo.achievements || "") +
          "</textarea></td>" +
          '<td><i class="icon-remove detailRemove" style="font-size: 18px; padding: 5px; cursor: pointer;"></i></td>' +
          "</tr>"
        );
      };

      getKey(yearData, "details", {});

      [
        {
          key: "patientcare",
          title: "<b>Patient Care and Clinical Excellence</b>",
          info: "•	<b>Care excellence:</b> Engagement in care coordination/ implementation for patients; Specific requests for your care; Awards/ acknowledgements/letters for care excellence\n•	<b>Specialty care areas:</b> unique patient populations/ specialty procedures/ referrals your care supports\n•	<b>Clinical service:</b> Staying late to complete cases; Coverage provided during holidays/conferences/retreats/staff shortages/staff illness to support the needs of department and colleagues\n•	<b>Formal activities:</b> QI/QA/Patient safety projects, clinical operations roles, protocol development/implementation\n•	<b>Informal activities:</b> Participation in initiatives/ innovations to enhance care for your patients"
        },
        {
          key: "scholarship",
          title: "<b>Scholarship and Research</b>",
          info: "•	<b>Lectures:</b> At local, regional, or national meetings/ conferences/ webinars\n•	<b>Traditional publications:</b> peer-reviewed manuscripts, guideline papers, book chapters, review articles, case-reports, poster/abstract presentations\n•	<b>Research:</b> Clinical, basic science, informatics, data science, quality improvement studies, etc.\n•	<b>Editorial work:</b> Journal editorship roles; book editorship roles \n•	<b>Awards:</b> Research or project grants/ awards/ recognitions (includes educational or clinical focuses)\n•	<b>Other publications/ knowledge dissemination:</b> non-peer reviewed manuscripts, online/ digital publications (websites, blogs, podcasts, interviews, graphics)\n•	<b>Innovation:</b> New technologies, patents, inventions, devices"
        },
        {
          key: "teaching",
          title: "<b>Teaching and/or Mentorship</b>",
          info: "•	<b>Didactic Activities:</b> Leading/ contributing to resident/fellow/medical student/other care professionals’ educational sessions or workshops\n•	<b>Development:</b> Creation of educational innovations, teaching materials, or programming, clinical rotation director\n•	<b>Educational Service/Leadership:</b> Education-related committees/ activities (eg. recruitment, CCC, education, oral boards practice); completion of trainee evaluations; Leadership of educational programs (course/workshop/clinical rotation director)\n•	<b>Honors:</b> Awards, acknowledgements, letters for teaching excellence\n•	<b>Mentorship:</b> Advising, formal mentor relationships, letters of recommendation/ support written for trainees or faculty for awards, promotion, new roles, fellowship, jobs, etc."
        },
        {
          key: "admin",
          title: "<b>Administrative Service and/or Leadership</b>",
          info: "•	<b>Local:</b> Formal leadership roles/ committees/ contributions in service of patients, trainees, divisions, or department\n•	<b>Institutional:</b> Formal leadership roles/committees/ contributions in service of hospital or school \n•	<b>External:</b> Formal leadership roles/committees external to the institution (eg. professional societies, organizations)\n•	<b>Advocacy:</b> DEI contributions, community outreach efforts, advocacy activities"
        }
      ].map(function (sectionInfo) {
        var detailInfo = getKey(yearData.details, sectionInfo.key, {});
        var detailList = getKey(detailInfo, "list", []);
        if (detailList.length == 0) detailList.push({});

        $("#careerConfStanfordAA").append(
          $(
            '<div style="display: block">' +
              '<h5 style="display: inline-block;">' +
              sectionInfo.title +
              "</h5>" +
              '<span class="glyphicon glyphicon-info-sign autoTip" data-toggle="popover" data-placement="right" data-content="Guidance" data-tip="' +
              sectionInfo.info +
              '" style="display: inline-block; cursor: pointer; padding: 5px; " data-source="" data-original-title="" title=""></span>' +
              "</div>"
          )
        );
        $("#careerConfStanfordAA").append(
          $(
            '<table data-key="' +
              sectionInfo.key +
              '" style="width: 100%;"><tbody>' +
              '<tr><td>Description</td><td style="width: 130px;">Support* (Yes/No)</td><td>Key achievements</td><td></td></tr>' +
              detailList
                .map(function (item, i) {
                  return getBasicRow(i, sectionInfo.key, item);
                })
                .join("") +
              "</tbody></table>" +
              (detailList.length >= 6 || isReadOnly(yearData, "mentee")
                ? ""
                : '<div data-key="' +
                  sectionInfo.key +
                  '" class="btn btn-default careerConfStanfordAddRow" style="margin: 5px;">Add Row - Max of 6</div>')
          )
        );
      });

      $(".careerConfStanfordAddRow")
        .unbind("click")
        .click(function () {
          var key = getProp(this, "key");
          var detailInfo = getKey(yearData.details, key, {});
          detailInfo.list.push({});
          updateHTML();
        });

      // These go under questions
      let questionIndicesGroup1 = [0, 1, 2, 3];

      questionIndicesGroup1.map(function (questionIndex, i) {
        var key = i + 1;
        let title = conference.questionCaptions[questionIndex];
        $("#careerConfStanfordAA").append($("<h5>" + title + "</h5>"));
        if (isReadOnly(yearData, "mentee")) {
          $("#careerConfStanfordAA").append(
            $(
              '<p style="display: inline-block;width:100%;padding: 4px;border: 1px solid grey;min-height: 28px;border-radius: 5px;background-color: #f4f4f4;">' +
                escapeHtml((yearData.questions[key] || {}).text || "")
                  .split("\n")
                  .join("<br>") +
                "</p>"
            )
          );
        } else {
          $("#careerConfStanfordAA").append(
            // width set to match getBasicRows width
            $(
              '<textarea class="form-control careerQuestionInput" style="width: 92%; height: 100px;" data-type="' +
                key +
                '"></textarea>'
            )
          );
          $('.careerQuestionInput[data-type="' + key + '"]').val(
            (yearData.questions[key] || {}).text
          );
        }
      });

      var topicList = [
        "Clinical Activities",
        "Scholarship",
        "Teaching",
        "Mentorship",
        "Institutional Service and Administrative Activities",
        "Leadership",
        "Professionalism and Collegiality",
        "Academic/professional support (mentorship, learning opportunities, resources)",
        "Quality Improvement Activities",
        "Contributions to Diversity and Inclusion",
        "Advocacy",
        "Professional Development",
        "Achievement of Career Goals",
        "Percent time of appointment and allocation of effort",
        "Any planned sabbatical or leave",
        "Financial Issues"
      ];

      var data = getKey(yearData, "data", {});

      var chairSign = getKey(data, "chairSign", {}); // { id: , time: }
      $("#stanfordSignChairLine").html(
        "<b>Signature of Chair/Chief/Delegate: </b><i>" +
          (chairSign.id == null
            ? "(Not Yet Signed)"
            : (users[chairSign.id] || { name: "" }).name +
              " (" +
              formatDate(new Date(chairSign.time)) +
              ")") +
          "</i>"
      );
      $("#stanfordSignChairButton")
        .toggle(!isReadOnly(yearData, "mentor", { noOverride: true }))
        .unbind("click")
        .click(function () {
          chairSign.id = user.id;
          chairSign.time = Date.now();
          refreshSection();
          $("#stanfordSignChairButton").text("Signed");
        });

      var menteeSign = getKey(data, "menteeSign", {}); // { id: , time: }
      $("#stanfordSignMenteeLine").html(
        "<b>Signature of Faculty Member: </b><i>" +
          (menteeSign.id == null
            ? "(Not Yet Signed)"
            : (users[menteeSign.id] || { name: "" }).name +
              " (" +
              formatDate(new Date(menteeSign.time)) +
              ")") +
          "</i>"
      );
      $("#stanfordSignMenteeButton")
        .toggle(!isReadOnly(yearData, "mentee", { noOverride: true }))
        .unbind("click")
        .click(function () {
          menteeSign.id = user.id;
          menteeSign.time = Date.now();
          refreshSection();
          $("#stanfordSignMenteeButton").text("Signed");
        });

      $("#careerConfStanfordCounsel").append(
        $(
          "" +
            `<div style="margin-top: 10px;display: inline-block;width: 100%;">
<h5 style="margin-bottom: 15px;display: inline-block; margin-right: 5px;">Date of Meeting:</h5>
<div id="ccStanfordMeetingDate" class="date" style="display: inline-block; margin-right: 8px;">
<input style="display: none;" value="${data.meetingDate}">
<div ${!isReadOnly(yearData, "mentor") ? "" : "disabled"} class="btn btn-sm btn-default redIfErr" style="font-size: 14px; padding-top: 1px; padding-bottom: 1px; text-align: center; width: 90px; box-shadow: 0 0 2px #aaa;vertical-align: top;">${(data.meetingDate || "") == "" ? "No Date" : data.meetingDate}</div>
</div>
</div>` +
            (last != null && last.role == "full"
              ? ""
              : `<div style="margin-top: 10px;display: inline-block;width: 100%;">
<h5 style="margin-bottom: 15px;display: inline-block; margin-right: 5px;">Current Appointment End Date:</h5>
<div id="ccStanfordAptEndDate" class="date" style="display: inline-block; margin-right: 8px;">
<input style="display: none;" value="${data.aptEndDate}">
<div ${!isReadOnly(yearData, "mentor") ? "" : "disabled"} class="btn btn-sm btn-default redIfErr" style="font-size: 14px; padding-top: 1px; padding-bottom: 1px; text-align: center; width: 90px; box-shadow: 0 0 2px #aaa;vertical-align: top;">${(data.aptEndDate || "") == "" ? "No Date" : data.aptEndDate}</div>
</div>
</div>
<div style="display: inline-block;width: 100%;">
<input value="reapt" type="radio" ${isReadOnly(yearData, "mentor") ? " disabled" : ""} style="margin-right: 10px;height: 15px;width: 15px;vertical-align: top;margin-top: 10px;cursor: pointer;" name="ccStanfordAptChoice">
<h5 style="margin-bottom: 15px;display: inline-block;width: calc(100% - 30px);">Reappointment</h5>  
</div>
<div style="display: inline-block;width: 100%;">
<input value="oneyear" type="radio" ${isReadOnly(yearData, "mentor") ? " disabled" : ""} style="margin-right: 10px;height: 15px;width: 15px;vertical-align: top;margin-top: 10px;cursor: pointer;" name="ccStanfordAptChoice">
<h5 style="margin-bottom: 15px;display: inline-block;width: calc(100% - 30px);">Promotion Review will be launched one year in advance of the current appointment end date.</h5>  
</div>
<div style="display: inline-block;width: 100%;">
<input value="tbd" type="radio" ${isReadOnly(yearData, "mentor") ? " disabled" : ""} style="margin-right: 10px;height: 15px;width: 15px;vertical-align: top;margin-top: 10px;cursor: pointer;" name="ccStanfordAptChoice">
<h5 style="margin-bottom: 15px;display: inline-block;width: calc(100% - 30px);">Type of review has not yet been determined. 
</h5>  
</div>`) +
            `<div style="margin-top: 15px;display: inline-block;width: 100%;">
<input id="ccStanfordReviewed" type="checkbox" ${data.reviewed ? " checked" : ""} ${isReadOnly(yearData, "mentor") ? " disabled" : ""} style="margin-right: 10px;height: 15px;width: 15px;vertical-align: top;margin-top: 10px;cursor: pointer;">
<h5 style="margin-bottom: 15px;display: inline-block;width: calc(100% - 30px);">The curriculum vitae for this faculty member was reviewed and discussed.</h5>  
</div>` +
            (last != null && last.role == "full"
              ? ""
              : `<div style="display: inline-block;width: 100%;">
<input id="ccStanfordDiscussed" type="checkbox" ${data.discussed ? " checked" : ""} ${isReadOnly(yearData, "mentor") ? " disabled" : ""} style="margin-right: 10px;height: 15px;width: 15px;vertical-align: top;margin-top: 15px;cursor: pointer;">
<h5 style="margin-bottom: 15px;display: inline-block;width: calc(100% - 30px);">I confirm that I have discussed criteria, review process steps/timelines, resources and progress toward next anticipated reappointment or promotion with the faculty member.</h5>  
</div>`) +
            `<div style="display: inline-block;width: 100%;">
<input id="ccStanfordReviewedMedhub" type="checkbox" ${data.reviewedMedhub ? " checked" : ""} ${isReadOnly(yearData, "mentor") ? " disabled" : ""} style="margin-right: 10px;height: 15px;width: 15px;vertical-align: top;margin-top: 10px;cursor: pointer;">
<h5 style="margin-bottom: 15px;display: inline-block;width: calc(100% - 30px);">I confirm that I have reviewed and discussed the available MedHub teaching evaluations from the past year with the faculty member.</h5>
</div>`
        )
      );

      if (!isReadOnly(yearData, "mentor")) {
        $("#ccStanfordMeetingDate")
          .on("changeDate changeMonth changeYear", function (e) {
            var inputEl = $(e.target).find("input");
            var btnEl = $(e.target).find(".btn");
            var val = inputEl.val();
            data.meetingDate = val;
            btnEl.text(val);
            checkSave();
          })
          .datepicker({
            format: "mm/dd/yyyy",
            forceParse: false,
            autoclose: true
          });
        $("#ccStanfordAptEndDate")
          .on("changeDate changeMonth changeYear", function (e) {
            var inputEl = $(e.target).find("input");
            var btnEl = $(e.target).find(".btn");
            var val = inputEl.val();
            data.aptEndDate = val;
            btnEl.text(val);
            checkSave();
          })
          .datepicker({
            format: "mm/dd/yyyy",
            forceParse: false,
            autoclose: true
          });
      }

      $("input[name=ccStanfordAptChoice][value=" + data.aptChoice + "]").prop(
        "checked",
        true
      );

      if (!isReadOnly(yearData, "mentor")) {
        $("#ccStanfordMeetingDate")
          .unbind("input")
          .on("input", function () {
            data.meetingDate = $(this).val();
            checkSave();
          });
        $("#ccStanfordAptEndDate")
          .unbind("input")
          .on("input", function () {
            data.aptEndDate = $(this).val();
            checkSave();
          });
        $('input[name="ccStanfordAptChoice"]')
          .unbind("change")
          .on("change", function () {
            data.aptChoice = $(this).val();
            checkSave();
          });
        $("#ccStanfordReviewed")
          .unbind("click")
          .on("click", function () {
            data.reviewed = $(this).is(":checked");
            checkSave();
          });
        $("#ccStanfordDiscussed")
          .unbind("click")
          .on("click", function () {
            data.discussed = $(this).is(":checked");
            checkSave();
          });
        $("#ccStanfordReviewedMedhub")
          .unbind("click")
          .on("click", function () {
            data.reviewedMedhub = $(this).is(":checked");
            checkSave();
          });
      }

      // This question needs to appear out of order
      $("#careerConfStanfordCounsel").append(
        $(`<h5>${conference.questionCaptions[9]}</h5>`)
      );
      if (isReadOnly(yearData, "mentor")) {
        $("#careerConfStanfordCounsel").append(
          $(
            '<p style="display: inline-block;width: 100%;padding: 4px;border: 1px solid grey;min-height: 28px;border-radius: 5px;background-color: #f4f4f4;">' +
              escapeHtml((yearData.questions[8] || {}).text || "")
                .split("\n")
                .join("<br>") +
              "</p>"
          )
        );
      } else {
        $("#careerConfStanfordCounsel").append(
          $(
            '<textarea class="form-control careerQuestionInput" style="height: 100px;" data-type="8"></textarea>'
          )
        );
        $('.careerQuestionInput[data-type="8"]').val(
          (yearData.questions[8] || {}).text
        );
      }

      var topics = getKey(data, "topics", {});

      $("#careerConfStanfordCounsel").append(
        $(
          "" +
            `<div style="margin-top: 10px;margin-bottom: 10px; display: inline-block;">
<h5 style="margin-bottom: 15px;">The following topics if applicable were discussed, key points provided to the faculty member regarding progress toward reappointment or promotion, and allocation of effort in each area reviewed:</h5>
<div>${topicList
              .map(function (topic) {
                return (
                  '<div class="btn btn-default ccStanfordTopic" data-topic="' +
                  topic +
                  '" style="margin-right: 10px;margin-bottom: 10px;"><span style="vertical-align: top;">' +
                  topic +
                  '</span><input type="checkbox" ' +
                  (isReadOnly(yearData, "mentor") ? " disabled" : "") +
                  " " +
                  (topics[topic] ? " checked" : "") +
                  ' style="margin-left: 5px; cursor: pointer;"></div>'
                );
              })
              .join(
                ""
              )}<div class="btn btn-default" style="margin-right: 10px;margin-bottom: 10px;padding-top: 2px;padding-bottom: 2px;padding-left: 5px;"><input type="text" style="width: 200px;height: 30px;" class="form-control ccStanfordOtherTopic" placeholder="Other" ${isReadOnly(yearData, "mentor") ? " disabled" : ""} />
<input type="checkbox" ${(data.otherTopic || "").length > 0 ? " checked" : ""} style="margin-left: 5px; cursor: pointer;" ${isReadOnly(yearData, "mentor") ? " disabled" : ""} />
</div></div>`
        )
      );

      $(".ccStanfordOtherTopic").val(data.otherTopic || "");

      if (!isReadOnly(yearData, "mentor")) {
        $(".ccStanfordOtherTopic")
          .parent()
          .unbind("click")
          .click(function () {
            if ((data.otherTopic || "") == "") {
              data.otherTopic = "Other";
            } else data.otherTopic = "";
            $(this).find('input[type="text"]').val(data.otherTopic);
            $(this)
              .find('input[type="checkbox"]')
              .prop("checked", data.otherTopic.length > 0);
            checkSave();
          });
        $(".ccStanfordOtherTopic")
          .unbind("click")
          .on("click", function (e) {
            e.stopPropagation();
          });
        $(".ccStanfordOtherTopic")
          .unbind("input")
          .on("input", function () {
            data.otherTopic = $(this).val().trim();
            $(this)
              .parent()
              .find('input[type="checkbox"]')
              .prop("checked", data.otherTopic.length > 0);
            checkSave();
          });

        $(".ccStanfordTopic")
          .unbind("click")
          .click(function () {
            var topic = getProp(this, "topic");
            topics[topic] = !topics[topic];
            $(this).find("input").prop("checked", !!topics[topic]);
            checkSave();
          });
      }

      let questionIndicesGroup2 =
        last != null && last.role ? [4, 5, 6] : [4, 7, 8];
      questionIndicesGroup2.map(function (questionIndex, i) {
        var key = i + 5;
        let title = conference.questionCaptions[questionIndex];
        $("#careerConfStanfordCounsel").append($("<h5>" + title + "</h5>"));
        if (isReadOnly(yearData, "mentor")) {
          $("#careerConfStanfordCounsel").append(
            $(
              '<p style="display: inline-block;width: 100%;padding: 4px;border: 1px solid grey;min-height: 28px;border-radius: 5px;background-color: #f4f4f4;">' +
                escapeHtml((yearData.questions[key] || {}).text || "")
                  .split("\n")
                  .join("<br>") +
                "</p>"
            )
          );
        } else {
          $("#careerConfStanfordCounsel").append(
            $(
              '<textarea class="form-control careerQuestionInput" style="height: 100px;" data-type="' +
                key +
                '"></textarea>'
            )
          );
          $('.careerQuestionInput[data-type="' + key + '"]').val(
            (yearData.questions[key] || {}).text
          );
        }
      });

      $(".careerQuestionInput")
        .unbind("input")
        .on("input", function () {
          var question = getProp(this, "type");
          var yearData = newDef.career[viewYear];
          var qData = getKey(yearData.questions, question, {
            text: "",
            mentorComments: ""
          });
          qData.text = $(this).val().trim();

          var wcBox = $('.wordLimit[data-type="' + question + '"]');
          if (wcBox.length > 0) {
            var numWords = qData.text.trim().split(/ +/).length;
            wcBox.text(
              qData.text.trim().length == 0
                ? "(250 word limit)"
                : "(" + numWords + "/250 word limit)"
            );
            wcBox.css("color", numWords > 250 ? "red" : "");
          }

          var logText =
            "q - " +
            question +
            " - text - " +
            qData.text +
            " - user " +
            (user || {}).id;
          backend.send("log", logText);

          checkSave();
          careerErrorCheck();
        });

      $(".detailInput1")
        .unbind("input")
        .on("input", function () {
          var key = getProp(this, "key");
          var i = parseInt(getProp(this, "i"));

          var yearData = newDef.career[viewYear];
          var detailInfo = getKey(yearData.details[key].list, i, {});
          detailInfo.text = $(this).val().trim();

          var logText =
            "detail text - " +
            key +
            " - " +
            i +
            " - " +
            detailInfo.text +
            " - user " +
            (user || {}).id;
          backend.send("log", logText);

          checkSave();
          careerErrorCheck();
        });

      $(".detailInput2")
        .unbind("change")
        .on("change", function () {
          var key = getProp(this, "key");
          var i = getProp(this, "i");

          var yearData = newDef.career[viewYear];
          var detailInfo = getKey(yearData.details[key].list, i, {});
          detailInfo.support = $(this).val().trim();

          var logText =
            "detail support - " +
            key +
            " - " +
            i +
            " - " +
            detailInfo.support +
            " - user " +
            (user || {}).id;
          backend.send("log", logText);

          checkSave();
          careerErrorCheck();
        });

      $(".detailInput3")
        .unbind("input")
        .on("input", function () {
          var key = getProp(this, "key");
          var i = getProp(this, "i");

          var yearData = newDef.career[viewYear];
          var detailInfo = getKey(yearData.details[key].list, i, {});
          detailInfo.achievements = $(this).val().trim();

          var logText =
            "detail achievements - " +
            key +
            " - " +
            i +
            " - " +
            detailInfo.achievements +
            " - user " +
            (user || {}).id;
          backend.send("log", logText);

          checkSave();
          careerErrorCheck();
        });

      $(".detailRemove")
        .unbind("click")
        .on("click", function () {
          var key = getProp(this, "key");
          var i = getProp(this, "i");

          var yearData = newDef.career[viewYear];
          yearData.details[key].list.splice(i, 1);

          var logText =
            "detail achievements - " +
            key +
            " - " +
            i +
            " - removed - user " +
            (user || {}).id;
          backend.send("log", logText);

          checkSave();
          careerErrorCheck();
          updateHTML();
        });

      $(".generalMentorComments")
        .toggle(!isReadOnly(yearData, "mentor"))
        .val(getKey(yearData, "mentorComments", ""))
        .parent()
        .toggleClass(
          "has-error",
          !isReadOnly(yearData, "mentor") &&
            (yearData.mentorComments || "").length == 0
        );

      $(".generalMentorCommentsText")
        .toggle(isReadOnly(yearData, "mentor"))
        .html(getKey(yearData, "mentorComments", "").split("\n").join("<br>"));

      $(".generalMentorComments")
        .unbind("input")
        .on("input", function () {
          var yearData = newDef.career[viewYear];
          yearData.mentorComments = $(this).val().trim();
          $(this)
            .parent()
            .toggleClass("has-error", yearData.mentorComments.length == 0);
          checkSave();
          careerErrorCheck();
        });

      updateLayout();
    };

    updateHTML();
  },
  manageSetup: function (
    settingsEl,
    { conference, updateConfDate, saveConference, hierarchyNames },
    user
  ) {
    const ccManage = new CCManage(conference, saveConference, updateConfDate, {
      includeSections: {
        cutoff: true,
        mentees: true,
        goals: false,
        questions: true,
        mentors: true,
        reminders: false,
        years: true
      },
      sortBy: "mentor",
      verbage: {
        mentor: "Mentor",
        mentee: "Mentee"
      }
    });
    ccManage.createSettingsElements(settingsEl);
    updateConfDate(conference);
    ccManage.createMentorsMenteesSection();
    ccManage.createAwesomplete();
    ccManage.hookMessageButton(user);
    ccManage.populateMenteesSection(hierarchyNames);
  }
};
